"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.Global = exports.Father = exports.Container = exports.CloseButton = exports.Background = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ramda = require("ramda");

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var Background = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: ", ";\n\n  ", " {\n    background-color: rgba(0, 0, 0, 0.3);\n    bottom          : 0;\n    left            : 0;\n    position        : fixed;\n    right           : 0;\n    top             : 0;\n    z-index         : 10;\n  }\n"])), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'block' : 'none';
}, _widths.mediaQueries.desktop);

exports.Background = Background;
Background.displayName = 'Background';

var CloseButton = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor  : pointer;\n  position: absolute;\n  right   : 15px;\n  top     : 15px;\n\n  ", " {\n    top  : 10px;\n    right: 10px;\n  }\n"])), _widths.mediaQueries.desktop);

exports.CloseButton = CloseButton;
CloseButton.displayName = 'CloseButton';

var Container = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  background-color: ", ";\n  bottom          : 0;\n  display         : flex;\n  flex-direction  : column;\n  left            : 0;\n  outline         : none;\n  overflow        : auto;\n  position        : fixed;\n  right           : 0;\n  top             : 0;\n  z-index         : 20;\n\n  ", " {\n    width        : ", "px;\n    margin       : auto;\n    top          : 15vh;\n    bottom       : 15vh;\n    border-radius: 10px;\n    box-shadow   :\n      0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);\n  }\n"])), _palette.palette.white, _widths.mediaQueries.desktop, _widths.widths.containerWidth);

exports.Container = Container;
Container.displayName = 'Container';

var Father = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items   : center;\n  display       : flex;\n  flex          : 1;\n  flex-direction: column;\n  overflow: ", ";\n"])), (0, _ramda.prop)('fatherOverflow'));

exports.Father = Father;
Father.displayName = 'Father';
var Global = (0, _styledComponents.createGlobalStyle)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  body {\n    overflow: ", ";\n  }\n"])), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen ? 'hidden' : 'auto';
});
exports.Global = Global;
Global.displayName = 'Global';

var Title = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items   : center;\n  display       : flex;\n  flex-direction: column;\n\n  & h2 {\n    color      : ", ";\n    font-size  : 20px;\n    line-height: 1.3;\n    text-align : center;\n    margin-left: ", "px;\n    margin-right: ", "px;\n  },\n"])), _palette.palette["default"], _widths.widths.base * 6, _widths.widths.base * 6);

exports.Title = Title;
Title.displayName = 'Title';